import { ValidateRule } from '@/coreDomainsModule/constant/validateRules';
import { FilterType } from '@/coreDomainsModule/entities/filter';
import { ImportFileType } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { i18n } from '@/i18n';

const t = i18n.t;

/**
 * バリデーションルール
 */
export const validateRuleKeyMap: Record<string, readonly ValidateRule[]> = {
  warehouseNumber: [ValidateRule.Required],
  warehouseName: [ValidateRule.Required],
  supplierNumber: [ValidateRule.Required],
  supplierName: [ValidateRule.Required],
  businessNumber: [ValidateRule.Required],
  businessName: [ValidateRule.Required],
  package: [ValidateRule.Required],
  warehouse: [ValidateRule.Required],
  customerNumber: [ValidateRule.Required],
  customerName: [ValidateRule.Required],
  salesDestinationNumber: [ValidateRule.Required],
  salesDestinationName: [ValidateRule.Required],
  unit: [],
  leadTime: [ValidateRule.Required, ValidateRule.HalfWidthRealNumber, ValidateRule.NegativeNumber],
  leadTimeUnit: [ValidateRule.Required],
  MOQ: [ValidateRule.HalfWidthRealNumber, ValidateRule.NegativeNumber],
  stdInventoryIndicesMin: [ValidateRule.Required, ValidateRule.HalfWidthRealNumber, ValidateRule.NegativeNumber],
  stdInventoryIndicesMax: [ValidateRule.Required, ValidateRule.HalfWidthRealNumber, ValidateRule.NegativeNumber],
  stdInventoryIndicesUnit: [ValidateRule.Required],
  endUser: [],
  manufacturer: [],
} as const;

/**
 * 入力フォームのタイプ
 */
export const inputTypeKeyMap: Record<string, 'text' | 'select'> = {
  warehouseNumber: 'select',
  warehouseName: 'select',
  supplierNumber: 'select',
  supplierName: 'select',
  businessNumber: 'select',
  businessName: 'select',
  package: 'select',
  warehouse: 'select',
  customerNumber: 'select',
  customerName: 'select',
  salesDestinationNumber: 'select',
  salesDestinationName: 'select',
  unit: 'text',
  leadTime: 'text',
  leadTimeUnit: 'select',
  MOQ: 'text',
  endUser: 'select',
  manufacturer: 'select',
  stdInventoryIndicesMin: 'text',
  stdInventoryIndicesMax: 'text',
  stdInventoryIndicesUnit: 'select',
} as const;

/**
 * セレクトボックスの選択肢
 */
export const selectOptionKeyMap = {
  leadTimeUnit: ['取引登録モーダル選択肢:単位:日', '取引登録モーダル選択肢:単位:週', '取引登録モーダル選択肢:単位:月'],
  stdInventoryIndicesUnit: ['取引登録モーダル選択肢:単位:日', '取引登録モーダル選択肢:単位:週', '取引登録モーダル選択肢:単位:月'],
};

/**
 * 集計取引に必要な入力値
 */
export const userInputOption = [
  'leadTime',
  'leadTimeUnit',
  'MOQ',
  'stdInventoryIndicesMin',
  'stdInventoryIndicesMax',
  'stdInventoryIndicesUnit',
] as const;

/**
 * 取引の値を登録する際のフィールド項目名
 */
export const selectOption = {
  [ImportFileType.Announce]: [
    'warehouseNumber',
    'warehouseName',
    'supplierNumber',
    'supplierName',
    'customerNumber',
    'customerName',
    'salesDestinationNumber',
    'salesDestinationName',
    'businessNumber',
    'businessName',
    'package',
  ],
  [ImportFileType.SalesResult]: [
    'warehouseNumber',
    'warehouseName',
    'supplierNumber',
    'supplierName',
    'customerNumber',
    'customerName',
    'salesDestinationNumber',
    'salesDestinationName',
    'businessNumber',
    'businessName',
    'package',
    'endUser',
  ],
  [ImportFileType.Inventory]: [
    'warehouseNumber',
    'warehouseName',
    'supplierNumber',
    'supplierName',
    'businessNumber',
    'businessName',
    'package',
    'unit',
    'manufacturer',
  ],
  [ImportFileType.Arrival]: [
    'warehouseNumber',
    'warehouseName',
    'supplierNumber',
    'supplierName',
    'businessNumber',
    'businessName',
    'package',
    'unit',
    'manufacturer',
  ],
} as const;

/**
 * セレクトボックスの入力値をSelectInputのFilterTypeの値に変換する
 * @param key - セレクトボックスの入力値
 */
export const keyMappingForSelectInput: { [key: string]: FilterType } = {
  warehouseNumber: 'WAREHOUSE_CODE',
  warehouseName: 'WAREHOUSE',
  supplierNumber: 'SUPPLIER_CODE',
  supplierName: 'SUPPLIER_NAME',
  customerNumber: 'CUSTOMER_CODE',
  customerName: 'CUSTOMER_NAME',
  salesDestinationNumber: 'SALES_DESTINATION_CODE',
  salesDestinationName: 'SALES_DESTINATION_NAME',
  businessNumber: 'BUSINESS_CODE',
  businessName: 'BUSINESS_NAME',
  package: 'PACKAGE_AMOUNT',
  leadTimeUnit: 'LEAD_TIME_UNIT',
  stdInventoryIndicesUnit: 'STD_INVENTORY_INDICES_UNIT',
  endUser: 'END_USER',
  manufacturer: 'MANUFACTURER',
} as const;
